<template>
<div id="serviteurs">
<v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{$t('dashboard._Valid_members_')}}: {{serviteurs.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        right
        append-icon="search"
        label="Recherche"
        single-line
        hide-details
      ></v-text-field>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>


    <download-excel
	class   = "btn btn-default"
	:data   = "serviteurs"
	:fields = "json_fields"
  type    = "csv"
	name    = "serviteurs_.csv">
  <button type="button" class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}}
</button> 
</download-excel>

        <v-data-table
          :headers="this.type == 'S' ? headers_serviteur:headers"
          :items="serviteurs"
          class="elevation-0"
          :pagination.sync="pagination"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <tr style="cursor: pointer">
            <td>
              <v-avatar size="36px">
                <img :src="props.item.imageUrl"/>
              </v-avatar>
            </td>
            <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.role }}</td>
            <td class="text-xs-left">{{ props.item.churchName }}</td>
            <td class="text-xs-left">{{ props.item.createdDate }}</td>
              <td class="text-xs-left" >
                 <div v-viewer class="images clearfix">

              <template >
                <img :src="props.item.qr_url" class="image" >
                </template>
            </div>
             
                </td>
         <td class="text-xs-right" v-if="this.type == 'S'">
               <v-btn @click.stop="deleteItem(props.item)" flat icon color="grey">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
                      <td class="text-xs-right">
               <v-btn @click.stop="editItem(props.item)" flat icon color="grey">
                 <v-icon>edit</v-icon>
              </v-btn>
            </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
/* eslint-disable */ 
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
export default {
      components: {
        
    },
  data () {
    return {
      search: '',
      loading: true,


          headers: [
          {
            text:this.$t('members._photo_'),
            align: 'left',
            sortable: false,
            value: 'imageUrl'
          },
          { text:this.$t('members._fullname_'), value: 'lastName' },
          { text:this.$t('members._phone_'), value: 'phone' },
          { text:this.$t('members._rule_'), value: 'role' },
          { text:this.$t('members._churchName_') , value: 'churchName' },
          { text:this.$t('members._createdDate_') , value: 'createdDate' },
          { text:this.$t('members._qrcode_'), value: 'qr_link' },
                   {
            text: this.$t('members._delete_'),
            align: 'left',
            sortable: false,
            value: ''
          },
           {
            text: this.$t('members._edit_'),
            align: 'left',
            sortable: false,
            value: ''
          }
        
        ],


        headers_serviteur: [
          {
            text:this.$t('members._photo_'),
            align: 'left',
            sortable: false,
            value: 'imageUrl'
          },
          { text:this.$t('members._fullname_'), value: 'lastName' },
          { text:this.$t('members._phone_'), value: 'phone' },
          { text:this.$t('members._rule_'), value: 'role' },
          { text:this.$t('members._churchName_') , value: 'churchName' },
          { text:this.$t('members._createdDate_') , value: 'createdDate' },
          { text:this.$t('members._qrcode_'), value: 'qr_link' },
                {
            text: this.$t('members._delete_'),
            align: 'left',
            sortable: false,
            value: ''
          },
           {
            text: this.$t('members._edit_'),
            align: 'left',
            sortable: false,
            value: ''
          }
        
        ],



         //fields: ['lastName', 'phone', 'accessCode','role','churchName','createdBy','createdDate'],
           json_fields: {
        'Nom et Prenom': 'lastName',
        'Telephone': 'phone',
        "Code d'accees":"accessCode",
         'Role': 'role',
          'Paroisse': 'churchName',
           'Cree par': 'createdBy',
            'Date cree': 'createdDate',
      },
        pagination: {
          sortBy: 'lastName',
          rowsPerPage: '100'
        },
    };
  },
  created() {
      let serviteurs2 = this.$store.getters.serviteurs;
 //  console.log("table 2"+ JSON.stringify(serviteurs2))
    this.created_by_id = firebase.auth().currentUser.uid;
     this.created_by = firebase.auth().currentUser.displayName;
 
  },
    mounted() {
     
    },
  computed: {
          type() {
      let user = this.$store.getters.signinUser;
      let type = user.type;
     
      return type;
    },
          ID() {
      let user = this.$store.getters.signinUser;
      let id = user.id;
      return id;
    },
    serviteurs() {
      let serviteurs = this.$store.getters.serviteurs;
      this.loading = false;
      return serviteurs;
    }
  },
  methods: {
    deleteItem(item) {
        if (confirm('Etes-vous sûre de vouloir supprimer ce membre?')) {
          this.$store.dispatch('deleteMember', item.id);
           alert(`Ce membre a été suprimé`);
        }
  },
      editItem(item) {  
       this.fetchCurrentMember(item.id);       
      },
       fetchCurrentMember (payload) {
     
      db.collection('Census').doc(payload)
      .get()
      .then((doc) => {
        const form = {
             id: doc.id,
             imageUrl: doc.data().imageUrl,
             firstName: doc.data().firstName,
             lastName: doc.data().lastName,
             posteName: doc.data().posteName,
             accessCode: doc.data().accessCode,
             role: doc.data().role,
             phone: doc.data().phone,
             email: doc.data().email,
             dateOfBirth: doc.data().dateOfBirth,
             address: doc.data().address,
             gender: doc.data().gender,
             consent: doc.data().consent,
             city: doc.data().city,
             postalCode: doc.data().postalCode,
             isWithChildren: doc.data().isWithChildren,
             hasSmartPhone: doc.data().hasSmartPhone,
             noPhoneReason: doc.data().noPhoneReason,
             isBuyPhoneReady: doc.data().isBuyPhoneReady,
             maritalStatus: doc.data().maritalStatus,
             noVolunteerReason: doc.data().noVolunteerReason,
             isVolunteer: doc.data().isVolunteer,
             hasChildren: doc.data().hasChildren,
             volunteerFrequency: doc.data().volunteerFrequency,
             niveauScolaire: doc.data().niveauScolaire,
             churchName: doc.data().churchName,
             churchAttendance: doc.data().churchAttendance,
             memberSince: doc.data().memberSince,
             sermonTimeSpent: doc.data().sermonTimeSpent,
             isreferralReady: doc.data().isreferralReady,
             noReferralReason: doc.data().noReferralReason,
             isVolunteerReady: doc.data().isVolunteerReady,
             noVolunteerReason: doc.data().noVolunteerReason,
             volunteerTime: doc.data().volunteerTime,
             noDonationReason: doc.data().noDonationReason,
             donation: doc.data().donation,
             isDimeContribution: doc.data().isDimeContribution,
             isDonationReady: doc.data().isDonationReady,
             // dimeAmount: doc.data().dimeAmount,
             dime: doc.data().dime,
             dimeType: doc.data().dimeType,
             isOffrandeContribution: doc.data().isOffrandeContribution,
             // offrandeAmount: doc.data().offrandeAmount,
             offrandeType: doc.data().offrandeType,
             offrande: doc.data().offrande,
             isGraceContribution: doc.data().isGraceContribution,
             // graceDonationAmount: doc.data().graceDonationAmount,
             graceContributionType: doc.data().graceContributionType,
             isWorking: doc.data().isWorking,
             createdDate: doc.data().createdDate,
             isWorkReady: doc.data().isWorkReady,
             notAvailableReason: doc.data().notAvailableReason,
             isEducationReady: doc.data().isEducationReady,
             education: doc.data().education,
             isHouseOwner: doc.data().isHouseOwner,
             houseOwnerSince: doc.data().houseOwnerSince,
             isRenting: doc.data().isRenting,
             jobSkills: doc.data().jobSkills,
             jobSearch: doc.data().jobSearch,
             jobType: doc.data().jobType,
             availableTime: doc.data().availableTime,
             jobDisponibility: doc.data().jobDisponibility,
             timeOnCurrentJob: doc.data().timeOnCurrentJob,
             jobPosition: doc.data().jobPosition,
             numberOfJobs: doc.data().numberOfJobs,
             jobRepartition: doc.data().jobRepartition,
             jobWeeklyHours: doc.data().jobWeeklyHours,
             jobTravelDistance: doc.data().jobTravelDistance,
             homeTravelDistance: doc.data().homeTravelDistance,
             jobTravelMode: doc.data().jobTravelMode,            
             jobTravelCost: doc.data().jobTravelCost,
             jobTravelTime: doc.data().jobTravelTime,
             jobMonthlyPay: doc.data().jobMonthlyPay
        }  
         if (doc.data().imageUrl === "./src/assets/avatar.png" ) {
           form.imageUrl = memberPhoto;
         } else {
           this.$store.commit('memberPhoto', form.imageUrl)
         }
         if (
          doc.data().isBuyPhoneReady === null ||
          doc.data().isBuyPhoneReady === undefined
         ) {
           form.isBuyPhoneReady = false;
         }
         if (
          doc.data().isVolunteerReady === null ||
          doc.data().isVolunteerReady === undefined
         ) {
           form.isVolunteerReady = "Non";
         }
         if (
          doc.data().volunteerTime === null ||
          doc.data().volunteerTime === undefined
         ) {
           form.volunteerTime = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
          if (
          doc.data().houseOwnerSince === null ||
          doc.data().houseOwnerSince === undefined
         ) {
           form.houseOwnerSince = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().offrande === null ||
          doc.data().offrande === undefined
         ) {
           form.offrande = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().donation === null ||
          doc.data().donation === undefined
         ) {
           form.donation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().dime === null ||
          doc.data().dime === undefined
         ) {
           form.dime = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().timeOnCurrentJob === null ||
          doc.data().timeOnCurrentJob === undefined
         ) {
           form.timeOnCurrentJob = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
           
          doc.data().jobSearch === null ||
          doc.data().jobSearch === undefined
         ) {
           form.jobSearch = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().graceDonation === null ||
          doc.data().graceDonation === undefined
         ) {
           form.graceDonation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().jobDisponibility === null ||
          doc.data().jobDisponibility === undefined
         ) {
           form.jobDisponibility = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
         if (
          doc.data().education === null ||
          doc.data().education === undefined
         ) {
          form.education = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
         if (
          doc.data().numberOfKids === null ||
          doc.data().noPhoneReason === undefined
         ) {
           form.numberOfKids = 0;
         }
         if (
          doc.data().noReferralReason === null ||
          doc.data().noReferralReason === undefined
         ) {
           form.noReferralReason = 'Pas de raison';
         }
         if (
          doc.data().noDonationReason === null ||
          doc.data().noDonationReason === undefined
         ) {
           form.noDonationReason = 'Pas de raison';
         }
         if (
          doc.data().notAvailableReason === null ||
          doc.data().notAvailableReason === undefined
         ) {
           form.notAvailableReason = 'Pas de raison';
         }
         form.consent = true
          this.$store.commit('currentMember', form)
        })
      this.$router.push('/form/newmember')
    },
  }
};
</script>

<style>
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>




// WEBPACK FOOTER //
// src/pages/widgets/Serviteurs.vue